// export const BACKEND_API_URL = "http://localhost:8080/api";
export const BACKEND_API_URL = "https://acornon.kr/api";

// export const LOGIN_REDIRECT_URI = "http://localhost:8080/api/auth/sns-login/callback";
export const LOGIN_REDIRECT_URI = "https://acornon.kr/api/auth/sns-login/callback";

export const LOGIN_ENABLED = true;
